import { CHECKOUT_STEP_1 } from 'constants/routes';
import { Form, Formik } from 'formik';
import { displayActionMessage } from 'helpers/utils';
import { useDocumentTitle, useScrollTop } from 'hooks';
import PropType from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';
import * as Yup from 'yup';
import { StepTracker } from '../components';
import withCheckout from '../hoc/withCheckout';
import PayPalPayment from './PayPalPayment';
import Total from './Total';
import { useDispatch, useSelector } from 'react-redux';
import firebase from 'services/firebase';
const FormSchema = Yup.object().shape({
  name: Yup.string()
    .min(4, 'Name should be at least 4 characters.')
    .required('Name is required'),
  cardnumber: Yup.string()
    .min(13, 'Card number should be 13-19 digits long')
    .max(19, 'Card number should only be 13-19 digits long')
    .required('Card number is required.'),
  expiry: Yup.date()
    .required('Credit card expiry is required.'),
  ccv: Yup.string()
    .min(3, 'CCV length should be 3-4 digit')
    .max(4, 'CCV length should only be 3-4 digit')
    .required('CCV is required.'),
  type: Yup.string().required('Please select paymend mode')
});

const Payment = ({ shipping, payment, subtotal }) => {
  useDocumentTitle('Check Out Final Step | TaKKa');
  useScrollTop();

  const { basket, user,allstate } = useSelector((state) => ({
    basket: state.basket,
    user: state.auth,
    allstate:state
  }));



  const initFormikValues = {
    name: payment.name || '',
    cardnumber: payment.cardnumber || '',
    expiry: payment.expiry || '',
    ccv: payment.ccv || '',
    type: payment.type || 'paypal'
  };

  const onConfirm = () => {
    displayActionMessage('Feature not ready yet :)', 'info');

  };

  if (!shipping || !shipping.isDone) {
    return <Redirect to={CHECKOUT_STEP_1} />;
  }
  return (
    <div className="checkout">
      <StepTracker current={3} />
      <Formik
        initialValues={initFormikValues}
        validateOnChange
        validationSchema={FormSchema}
        validate={(form) => {
          if (form.type === 'paypal') {


            displayActionMessage('Your Order has been completed, we will contact you soon!', 'success');

            firebase.clearBasketItems( firebase.auth.currentUser.uid)
            .then(() => {
              console.log('Cleared basket');
            })
            .catch((e) => {
              console.log(e);
            });


let shippingDetails = allstate.checkout.shipping;
            basket.forEach(item =>{
              let finalOrder = {};

              finalOrder.Ruser = firebase.auth.currentUser.email;
              finalOrder.Ruserid = firebase.auth.currentUser.uid;


              finalOrder.address = shippingDetails.address;
              finalOrder.mobile = shippingDetails.mobile;
              finalOrder.Name = shippingDetails.fullname;
              finalOrder.note = shippingDetails.note;

              finalOrder.orderState = 'Requested';
              finalOrder.ProductName = item.name;
              finalOrder.Qty = item.quantity;
              finalOrder.maxQty = item.maxQuantity;
              finalOrder.price = item.price;


              firebase.confirmUserProducts(finalOrder);



            }
           )


          }
        }}
        //onSubmit={onConfirm}
      >
        {() => (
          <Form className="checkout-step-3">
            <PayPalPayment />
            <Total
              isInternational={shipping.isInternational}
              subtotal={subtotal}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

Payment.propTypes = {
  shipping: PropType.shape({
    isDone: PropType.bool,
    isInternational: PropType.bool
  }).isRequired,
  payment: PropType.shape({
    name: PropType.string,
    cardnumber: PropType.string,
    expiry: PropType.string,
    ccv: PropType.string,
    type: PropType.string
  }).isRequired,
  subtotal: PropType.number.isRequired
};

export default withCheckout(Payment);
